'use client';

import React from 'react';
import classnames from 'classnames';

import styles from './AspectRatio.module.scss';

type AspectRatioValue = '16:10' | '16:9' | '21:8' | '2:1' | '4:3' | '5:6' | '1:1';

const ratioClassName: Record<AspectRatioValue, string> = {
  '16:10': 'sixteenByTen',
  '16:9': 'sixteenByNine',
  '21:8': 'twentyOneByEight',
  '2:1': 'twoByOne',
  '4:3': 'fourByThree',
  '5:6': 'fiveBySix',
  '1:1': 'oneByOne',
};

export interface AspectRatioProps extends React.HTMLAttributes<HTMLDivElement> {
  ratio?: AspectRatioValue;
  children: React.ReactNode;
  responsive?: boolean;
  className?: string;
}

const AspectRatio: React.FC<AspectRatioProps> = ({
  ratio = '16:9',
  children,
  style,
  className,
  responsive = true,
  ...props
}) => {
  return (
    <div
      className={classnames(
        styles.container,
        styles[ratioClassName[ratio]],
        {
          [styles.responsive]: responsive,
        },
        className
      )}
      style={style}
      {...props}
    >
      <div className={styles.content}>{children}</div>
    </div>
  );
};

AspectRatio.displayName = 'AspectRatio';

export default AspectRatio;
